export { parse } from "./parse.js";
export { parseModule } from "./parse/parser.js";
export { lint, type Diagnostic, type Fix, type LintFixResult, type LintOptions } from "./lint.js";
export { run } from "./run.js";
export type { RunClock, RunClockSnapshot, RunRandom } from "./run.js";
export { noopOtelSink } from "./observability/otel.js";
export type { OtelSink, OtelSpan } from "./observability/otel.js";
export { FileSnapshotBackend } from "./snapshot/backend.js";
export type { Snapshot, SnapshotBackend } from "./snapshot/backend.js";
export { declareHostOperation } from "./interp/host-bridge.js";
export { HostCallResumabilityError } from "./interp/host-call.js";
export type {
  HostCallLifecycle,
  HostCallOutcome,
  HostCallRecord,
  HostCallResumeProof,
  HostCallResumeProvider,
  HostCallResumeRequest
} from "./interp/host-call.js";
export {
  HostOperationResumePolicyError,
  registerPendingHostCallPolicy
} from "./snapshot/policy.js";
export type {
  PendingHostCallPolicyMode,
  PendingHostCallPolicyRegistration
} from "./snapshot/policy.js";
export { dump } from "./dump.js";
export { restore } from "./restore.js";
export { SnapshotValidationError } from "./snapshot/validation.js";
export type { SnapshotValidationCode } from "./snapshot/validation.js";
export { Budget, SandboxError } from "./interp/budget.js";
export type { BudgetName, BudgetOptions } from "./interp/budget.js";
export { formatInterpreterError, type InterpreterDiagnostic } from "./error/format.js";
export { deepCopyFromSandbox, deepCopyToSandbox } from "./interp/values.js";
export { runHarness, runHarnessPair } from "./runner/run-harness.js";
export { extractBlock } from "./loader/extract-block.js";
export { findExportedConstInitializer } from "./loader/find-exported.js";
export { splitFrontmatter } from "./loader/frontmatter.js";
export type { ExportDefaultDeclaration, ExportNamedDeclaration, MetaProperty } from "./parse.js";
export {
  createSpawnUsageAccumulator,
  makeAgentModule,
  runWithSpawnUsageAccumulator
} from "./modules/agent.js";
export type {
  AgentModuleDefinition,
  AgentModuleOptions,
  AgentModuleParallelCall,
  AgentModuleRetryOptions,
  AgentModuleSpawnOptions,
  AgentSpawnEvent,
  SpawnAgent,
  SpawnAgentInput,
  SpawnAgentResult,
  SpawnUsageAccumulator,
  SpawnUsageTotal
} from "./modules/agent.js";
export { makeEnvModule } from "./modules/env.js";
export { makeFailModule } from "./modules/fail.js";
export { makeFsModule } from "./modules/fs.js";
export type {
  FsImplementation,
  FsModule,
  FsModuleOptions,
  SandboxDirent,
  SandboxStats
} from "./modules/fs.js";
export { makeGitModule } from "./modules/git.js";
export { makeHarnessModule } from "./modules/harness.js";
export { makeLogModule } from "./modules/log.js";
export { makeMetricModule } from "./modules/metric.js";
export { makeMcpModule } from "./modules/mcp.js";
export { makeTimeModule } from "./modules/time.js";
